import React, { useState } from 'react';
import SelectDropdown from './SelectDropDowns';
import ProjectAPI from '../../api/project';

export const MovingOptions = [
  { value: 'moving_home', label: 'Just moved into a new home' },
  { value: 'first_time_buyer', label: 'First-time buyer' },
  { value: 'improving', label: 'Improving my home' },
  { value: 'extending', label: 'Extending my home' },
  { value: 'renting', label: 'Renting my home' },
  { value: 'selling', label: 'Selling my home' },
];

export const OwnershipStageOptions = [
  { value: 'waiting_new_home', label: 'Waiting to complete on my new home' },
  { value: 'moved_12_month', label: 'Just moved in - less than 12 months ago' },
  { value: 'moved_2_years', label: 'Moved in the last 12-24 months' },
  { value: 'improving', label: "Improving my home that I've lived in for more than 2 years" },
];

export const HomeActivitiesOptions = [
  { value: 'selling', label: 'Selling your home' },
  { value: 'improving', label: 'Improving and staying in your home' },
  { value: 'renting', label: 'Renting your home' },
  { value: 'extending', label: 'Extending your home' },
];

export const CompletionTimelineOptions = [
  { value: 'immediately', label: 'Immediately' },
  { value: 'weeks_4', label: 'In the next 4 weeks' },
  { value: 'months_3', label: '1-3 months' },
  { value: 'months_3_plus', label: '3 months +' },
];

const OldNewOptions = [
  { value: '', label: '' },
  { value: 'period_property', label: 'Period property' },
  { value: 'new_build', label: 'New build' },
  { value: 'other', label: 'Other' },
];

const professionOptions = [
  { value: '', label: '' },
  { value: 'arts_entertainment', label: 'Arts/ Entertainment' },
  { value: 'construction_trades', label: 'Construction / Trades' },
  { value: 'customer_service', label: 'Customer service' },
  { value: 'education', label: 'Education' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'finance', label: 'Finance' },
  { value: 'government', label: 'Government' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'law', label: 'Law' },
  { value: 'retail', label: 'Retail' },
  { value: 'sales_marketing', label: 'Sales / Marketing' },
  { value: 'technology', label: 'Technology' },
  { value: 'other', label: 'Other' },
];

const customerOptions = [
  { value: '', label: '' },
  { value: 'single_person', label: 'Single person' },
  { value: 'empty_nesters', label: 'Empty nesters' },
  { value: 'couple_with_no_kids', label: 'Couple with no kids' },
  { value: 'parents_with_kids', label: 'Parents with kids' },
  { value: 'single_parent', label: 'Single parent' },
  { value: 'multi_generations_under_one_roof', label: 'Multi generations under one roof' },
  { value: 'other', label: 'Other' },
];

const genderOptions = [
  { value: '', label: '' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

const ProjectInfoDesigner = ({ project, updateProject }) => {
  const changeHandler = attributeName => {
    return value => {
      const params = { questionnaire_attributes: { [attributeName]: value } };
      ProjectAPI.update(project, params).then(({ project: newProject }) => {
        updateProject(newProject);
      });
    };
  };

  const [text, setText] = useState(project.mbr_note.text || '');
  const [hidden, setHidden] = useState(true);

  const toggleHiddenNotes = () => {
    setHidden(!hidden);
  };

  return (
    <div className="project-feedback -cust_information">
      <div className="project-feedback_subtitle">
        <span className="newTitle">Customer Information</span>
        <button
          className="btn -gold"
          type="button"
          onClick={() => {
            toggleHiddenNotes();
          }}
        >
          {hidden ? 'Show' : 'Hide'}
        </button>
      </div>
      <div className={`project-feedback_description newPara  ${hidden ? '-hidden' : ''}`}>
        Please add this information if/when you learn it! It is not compulsory to ask the customer
        these questions.
      </div>
      <div className={`project-feedback_note-wrapper  ${hidden ? '-hidden' : ''}`}>
        <SelectDropdown
          selectTitle="Old or new style home"
          project={project}
          options={OldNewOptions}
          value={project.questionnaire.home_style}
          changeHandler={changeHandler('home_style')}
        />
        <SelectDropdown
          selectTitle="Profession"
          project={project}
          options={professionOptions}
          value={project.questionnaire.profession}
          changeHandler={changeHandler('profession')}
        />
        {false && (
          <SelectDropdown
            selectTitle="Customer persona"
            project={project}
            options={customerOptions}
            value={project.questionnaire.customer_persona}
            changeHandler={changeHandler('customer_persona')}
          />
        )}
        {false && (
          <SelectDropdown
            selectTitle="Gender"
            project={project}
            options={genderOptions}
            value={project.questionnaire.gender}
            changeHandler={changeHandler('gender')}
          />
        )}
      </div>
    </div>
  );
  // }
};

export default ProjectInfoDesigner;



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Workdesk/components/ProjectFeedback/ProjectInfoDesigner.js